export default __webpack_public_path__ + "static/media/passLogo.61c3f4c3.svg";